<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <slot name="trigger">
        <aha-icon
          name="kebab-menu"
          width="18"
          height="18"
          viewBox="0 0 14 14"
        />
      </slot>
    </div>
    <aha-context-menu
      ref="context-menu"
      :target="id"
      :x="targetX"
      :y="targetY"
      forceMenuPosition
    >
      <aha-context-menu-header>
        <slot name="header" />
      </aha-context-menu-header>

      <slot name="items" />
    </aha-context-menu>
  </div>
</template>
context
<script>

export default {
  props: {
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
  },
  data() {
    return {
      targetX: null,
      targetY: null,
    }
  },
  methods: {
    // Just extend this component and override this to correct the postion of the context menu
    handleIconClick() {
      const icon = document.getElementById(this.id)
      if (!icon) return
      const { right } = icon.getBoundingClientRect()
      this.targetX = window?.innerWidth - right - 15
      this.targetY = icon.offsetTop + icon.offsetHeight - 8
      this.$refs['context-menu'].show()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
